var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@appspotr/ui-kit';
import { ModalContentWrapper, ActionBlock, TitleBlock, SubTitleBlock, AppTopMenuIcon, } from './styles';
import QRCode from 'react-qr-code';
import Popover from '../../components/Popover';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import { TooltipTopBar } from '../utils/tooltipConfig';
var PreviewPopOver = function (_a) {
    var isVisiblePreviewPopOver = _a.isVisiblePreviewPopOver, setIsVisiblePreviewPopOver = _a.setIsVisiblePreviewPopOver, app = _a.app;
    var previewUrl = "https://dev-mode-".concat(app.id).concat(process.env.APP_BASE_URL);
    var handleWindowOpen = function () {
        window.open(previewUrl, "App Preview: ".concat(app.id), 'resizable=no,width=400,height=840');
    };
    return (_jsx(Popover, __assign({ body: _jsxs("div", __assign({ onClick: function (e) { return e.stopPropagation(); } }, { children: [_jsx(TitleBlock, { children: "Live Preview" }), _jsx(SubTitleBlock, { children: "Scan the QR code with your device." }), _jsx(ModalContentWrapper, { children: (app === null || app === void 0 ? void 0 : app.id) ? _jsx(QRCode, { size: 244, value: previewUrl }) : 'Loading' }), _jsx(ActionBlock, { children: _jsx(Button, __assign({ onClick: handleWindowOpen, style: {
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                        } }, { children: (app === null || app === void 0 ? void 0 : app.id) ? 'Preview in window' : 'Loading' })) })] })), tipSize: 0.1, offset: -52, isOpen: isVisiblePreviewPopOver, preferPlace: "left", enterExitTransitionDurationMs: 1, bgColor: "#fff", borderColor: "#fff", bodyStyle: {
            borderRadius: '8px',
            boxShadow: '2px 2px 16px rgba(0, 0, 0, 0.2)',
            width: '280px',
        }, popoverStyle: {
            marginTop: '102px',
        }, onOuterAction: function () { return setIsVisiblePreviewPopOver(false); } }, { children: _jsx(TooltipTopBar, __assign({ title: 'App Preview' }, { children: _jsx(AppTopMenuIcon, { icon: faEye, onClick: function () {
                    setIsVisiblePreviewPopOver(!isVisiblePreviewPopOver);
                } }) })) })));
};
export default PreviewPopOver;
